import React from 'react'

import './action-header.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    left?: React.ReactNode
    right?: React.ReactNode
  }
>

const ActionHeader = ({className, left, right, ...props}: Props) => (
  <div {...props} className={cn('ActionHeader', {}, className)}>
    <div className="ActionHeader__left">{left}</div>
    <div className="ActionHeader__right">{right}</div>
  </div>
)

export default ActionHeader
